import ConfigForm, {
  ConfigInput,
  FormOption,
} from "components/Layout/ConfigForm";
import React from "react";

export interface DataUsagePromptProps {
  minutes: number;
  handleMinutesChange: (minutes: number) => void;
}

const minutesOptions: FormOption[] = [
  {
    label: "1",
    value: 1,
  },
  {
    label: "5",
    value: 5,
  },
  {
    label: "10",
    value: 10,
  },
  {
    label: "60",
    value: 60,
  },
];

export default function DataUsagePrompt({
  minutes,
  handleMinutesChange,
}: DataUsagePromptProps) {
  const _handleMinutesChange = (event: any) => {
    const newMinutes = minutesOptions.find((minute) => {
      return minute.label === event.target.value;
    });
    if (newMinutes) {
      handleMinutesChange(newMinutes.value as number);
    }
  };
  const inputs: ConfigInput[] = [
    {
      title: "For How Many Minutes",
      type: "radio",
      onChange: _handleMinutesChange,
      xs: 12,
      sm: 12,
      id: "trackingType",
      placeholder: "select tracking type",
      options: minutesOptions,
      value: minutes,
    },
  ];
  return <ConfigForm inputs={inputs} />;
}
